var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTvFilled = function SvgTvFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tv-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8630",
    d: "M0-47.5h16.469v16.469H0z",
    transform: "translate(0 47.5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.766 .766)",
    "data-name": "Group 5873",
    clipPath: "url(#tv-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8624",
    d: "M15.602 13.868a1.7 1.7 0 01-1.735 1.733H2.601a1.7 1.7 0 01-1.734-1.733V5.634A1.7 1.7 0 012.601 3.9h11.266a1.7 1.7 0 011.734 1.734z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8625",
    d: "M9.666 4.936a.433.433 0 010 .613.433.433 0 01-.613 0L5.066 1.565a.433.433 0 010-.613.433.433 0 01.613 0z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8626",
    d: "M6.803 4.936a.433.433 0 000 .613.433.433 0 00.613 0L11.4 1.565a.433.433 0 000-.613.433.433 0 00-.613 0z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8627",
    d: "M8.234 5.201c3.467 0 4.334.433 4.767.867s.867 1.3.867 3.467-.433 3.034-.867 3.466-1.3.867-4.767.867-4.334-.433-4.767-.867-.867-1.3-.867-3.467.433-3.034.867-3.467 1.3-.866 4.767-.866",
    fill: "#439aff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8628",
    d: "M13.435 14.085a.65.65 0 01.65-.65.65.65 0 01.65.65.65.65 0 01-.65.65.65.65 0 01-.65-.65",
    fill: "#66757f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8629",
    d: "M1.734 14.085a.65.65 0 01.65-.65.65.65 0 01.65.65.65.65 0 01-.65.65.65.65 0 01-.65-.65",
    fill: "#66757f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 32",
    d: "M9.646 9.304a.5.5 0 01.014.832L8.08 11.229a.5.5 0 01-.783-.403L7.26 8.694a.5.5 0 01.77-.429z",
    fill: "#fff"
  }))));
};
export default SvgTvFilled;